<script setup lang="ts">
  import { IFormItem, IRtl } from '../utils/interfaces';
  import { useCountrySelection } from '../hooks/useCountrySelection';
  import ContactFormPrivacyInfo from './ContactFormPrivacyInfo.vue';

  interface ContactFormPrivacyOptionProps {
    formItem: IFormItem,
    rtlItem: IRtl
  }

  defineProps<ContactFormPrivacyOptionProps>();
  const { currentCountry, countrySelectionMade, countryNameList, selectedCountryItem } = useCountrySelection();
</script>

<template>
  <div class="privacy-options-container">
    <div class="country-selection">
      <div class="dropdown-intro">{{ formItem.formCountryLabel }}</div>
      <v-select
        :options="countryNameList"
        v-model="currentCountry"
        :aria-label="formItem.formCountryLabel"
        :placeholder="formItem.formCountryPlaceholder"
        :dir="rtlItem.currentDirection"
        :class="{ 'text-rtl': rtlItem.useRtl }"
        data-pw-form="privacy-country"
      >
        <template #no-options>
          <div>{{ formItem.formCountryErrorMessage }}</div>
        </template>
      </v-select>
    </div>
    <div class="privacy-info">
      <contact-form-privacy-info 
        :isActive="countrySelectionMade"
        :formItem="formItem"
        :country-item="selectedCountryItem"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @use "../../site/variables";
  @use "../../site/mixins";

  .dropdown-intro {
    @include mixins.dropdown-styles-basic;
  }

  :deep(.vs__dropdown-toggle) {
    @include mixins.dropdown-toggle;
  }

  .text-rtl :deep(.vs__search),
  .text-rtl :deep(.vs__selected) {
    padding-right: 1.5rem;
  }

</style>